export let mock_menu = {};



// WEBPACK FOOTER //
// ./src/mocks/menu/index.ts